/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import type {AdobeMetricsRuntime, FetchFn} from './AdobeMetricsRuntime';
import type {DigitalData} from '@exc/metrics';
import MetricsRuntime from './MetricsRuntime';
export default MetricsRuntime;

export type {default as Configuration} from './Configuration';
export {AdobeMetricsRuntime};
export {default as MetricsNetworkIntercept} from './MetricsNetworkIntercept';
export {default as MetricsInteractionIntercept} from './MetricsInteractionIntercept';

declare global {
  interface Window {
    _originalFetch?: FetchFn;
    _XHRintercept?: boolean;
    adobeMetrics: AdobeMetricsRuntime;
    XMLHttpRequest: typeof XMLHttpRequest & {
      prototype: XMLHttpRequest & {
        _open?: typeof XMLHttpRequest.prototype.open;
        _setRequestHeader?: typeof XMLHttpRequest.prototype.setRequestHeader;
        _send?: typeof XMLHttpRequest.prototype.send;
      };
    };
    _satellite?: {
      track: (name: string) => void;
    };
    digitalData?: DigitalData;
  }
}
